export class ChartConstants {
  chartTitle: string;
  datakeys: string[];
  xAxis: string[];
  xAxisLabel: {};
  chartType: string;
  size: string;
  innersize: string;
  colors: any;
  labels: object;
  tooltips: any;
  datalabels: any;
  legend: any;
  yAxisLabels: any;
  yAxisTitle: string;
  stacking: string;
  plotOptions: {};
  sliced: any;
  credits: {};
}
